import { QueryFeature } from '../../../../config/queryClient';

enum QueryKey {
  Goals = 'Goals',
  MonteCarlo = 'MonteCarlo',
  Longevity = 'Longevity',
  SocialSecurity = 'SocialSecurity',
  MarketScenarios = 'MarketScenarios',
}

export const queryKeys = {
  monteCarlo: (clientId: string, fpId: string) => [
    QueryFeature.FinancialPlan,
    QueryKey.MonteCarlo,
    clientId,
    fpId,
  ],

  longevity: (clientId: number, fpId: string) => [
    QueryFeature.FinancialPlan,
    QueryKey.Longevity,
    clientId,
    fpId,
  ],

  socialSecurity: (clientId: number, fpId: string) => [
    QueryFeature.FinancialPlan,
    QueryKey.SocialSecurity,
    clientId,
    fpId,
  ],

  marketScenarios: (clientId: number, fpId: string) => [
    QueryFeature.FinancialPlan,
    QueryKey.MonteCarlo,
    QueryKey.MarketScenarios,
    clientId,
    fpId,
  ],
};
